<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="left-right-row row">
                    <div class="left">
                        <div class="col-sm-12">
                            <user-select-component
                                v-if="user.admin_access"
                                v-model="userId"
                                autoselect
                            />
                        </div>
                    </div>
                    <div class="right">
                        <router-link
                            :to="{ name: 'cpc-forms.new' }"
                            class="btn btn-primary mb-2"
                        >
                            <i class="fa fa-plus" /> New Form
                        </router-link>
                        <a
                            v-if="userId"
                            :href="`/api/cpc-forms/download?user_id=${userId}`"
                            target="_blank"
                            class="btn btn-info mb-2"
                        >
                            <i class="fa fa-download" /> Download PDF
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="row"
            v-if="loading"
        >
            <div class="col-sm-12">
                Loading
                <i class="fa fa-spinner fa-spin" />
            </div>
        </div>

        <div
            class="row"
            v-if="!loading && !forms.length"
        >
            <div class="col-sm-12">
                No CPD Forms
            </div>
        </div>

        <div class="row">
            <div
                v-for="form in forms"
                :key="form.id"
                class="col-md-4"
            >
                <div class="card">
                    <router-link
                        class="card-body"
                        style="cursor:pointer;"
                        tag="div"
                        :to="{name: 'cpc-forms.edit', params: {id: form.id}}"
                    >
                        <p class="text-info">
                            {{ form.form_date.format('Do MMM YYYY') }}
                        </p>
                        <h2>{{ form.title }}</h2>
                        <p>{{ form.hours }} hours</p>
                        <p v-if="user.admin_access">
                            {{ form.user.name }}
                        </p>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CPCFormService from "../../../services/CPCFormService";
import UserSelectComponent from "../../UserSelectComponent.vue";
import Auth from "../../../mixins/Auth";

export default {
    components: {UserSelectComponent},
    mixins: [
        Auth,
    ],
    data: function () {
        return {
            loading: false,
            forms: [],
            userId: null,
            token: null,
        };
    },

    watch: {
        userId: {
            handler: function () {
                this.loading = true;
                CPCFormService.index({
                    user_id: this.userId,
                })
                    .then(response => {
                        this.forms = response.data.map(form => ({
                            ...form,
                            form_date: window.moment(form.form_date),
                        }));
                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;
                        console.error(error);
                    });
            },
            immediate: true,
        }
    },

    mounted: function () {
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/office/cpc-forms/IndexComponent.vue